export default __webpack_public_path__ + "static/media/scratching-your-travel-itch.e81b092b.gif";